var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrowButtonDisabled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 60,
    viewBox: "0 0 66 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2402_6643",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 66,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: -0.5,
    width: 59,
    height: 64.5025,
    transform: "matrix(0 -1 -1 0 65 59)",
    fill: "#D9D9D9",
    stroke: "#BBBBBB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2402_6643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3485 42.1342L34.3401 42.142L34.3317 42.1342L11.8918 21.5794L7.06589 26L34.3401 50.983L61.6143 26L56.7884 21.5795L34.3485 42.1342Z",
    fill: "#BBBBBB",
    stroke: "#BBBBBB",
    strokeWidth: 0.025
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowButtonDisabled);
export default __webpack_public_path__ + "static/media/downArrowButtonDisabled.fe21e039f83c3ece5664f6f4f58e9017.svg";
export { ForwardRef as ReactComponent };